import { clearIntentMarker, readIntentMarker } from "./intent-marker";

export interface IntentOverride {
  navigateTo: string;
}

/**
 * Decide whether to override the post-onboarding destination because
 * the merchant arrived from a TOFU intent-only ad. If so, return the
 * in-app path to navigate to and clear the marker as a side effect
 * (one-shot consumption — a later home visit must not re-trigger the
 * redirect).
 *
 * Returns null when:
 *   - there is no marker (the normal case for organic installs)
 *   - the marker is expired or malformed (handled inside
 *     readIntentMarker — see intent-marker.ts for TTL semantics)
 *   - teamId is missing (defensive — Onboarding should only run with a
 *     loaded team, but a null guard avoids constructing /stores//...)
 */
export function consumeIntentAdOverride(
  teamId: string | undefined | null,
): IntentOverride | null {
  if (!teamId) {
    return null;
  }
  if (!readIntentMarker()) {
    return null;
  }
  clearIntentMarker();
  return { navigateTo: `/stores/${teamId}/conversion/intent-setup` };
}
